
import localisation_commune from "../../../assets/images/localisation-commune.svg";
export const DetailProspectionIntro = ({commune}) => {
    return (
        <>
            <div className="bg-beige p-4 mb-5 rounded-0 d-flex flex-wrap gap-3 gap-md-5 text-center text-sm-start align-items-center justify-content-center">
                <div className="d-flex flex-column align-items-center flex-shrink-0" style={{ minWidth:120}}>
                    <img src={localisation_commune} alt="" className="mb-2" style={{ width: 60, height: 60 }} />
                    <span className="fw-b text-uppercase">{commune}</span>
                </div>
                <p className="mb-0 col-lg-6">
                    Découvrez la carte de votre commune avec la localisation des points de prélèvements,
                    les dates et les résultats de prospection...
                </p>
            </div>
        </>
    )
}